<template>
  <main id="main">
    <div class="header_page">
      <p id="title_header_page">پروفایل استادان</p>
      <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </div>

    <div class="p-3">
      <div class="search d-flex align-items-center justify-content-between mb-4">
        <div class="d-flex align-items-center justify-content-center bg_white p-4 rounded-pill shadow_input cursor-pointer" @click="toggleSort">
          <img src="@/assets/imgs/sort.svg" class="icon-size-4" alt="">
        </div>
        <div class="position-relative w-80">
          <input 
            type="search" 
            class="shadow_input bg_white p-4 rounded-pill w-100" 
            placeholder="جستجوی نام استاد"
            v-model="searchQuery"
            @input="handleSearch"
          >
          <img src="@/assets/imgs/search.svg" class="icon-size-4 center_y start-5 position-absolute" alt="">
        </div>
      </div>

      <div v-if="loading" class="text-center mt-5">
        <p>در حال دریافت معلومات...</p>
      </div>

      <div v-else-if="teachers.length === 0" class="text-center mt-5 text_color_gray">
        موردی یافت نشد.
      </div>

      <div v-else>
        <div 
          v-for="teacher in teachers" 
          :key="teacher.teacher_id" 
          class="d-flex justify-content-between shadow-sm p-2 bg_white rounded-5 mb-3 cursor-pointer" 
          @click="goToProfile(teacher.teacher_id)"
        >
          <img 
            style="width: 9rem; height: 9rem; object-fit: cover;" 
            :src="teacher.pic1 || require('@/assets/imgs/NoPath - Copy (5).png')" 
            class="rounded-5" 
            alt=""
            @error="$event.target.src = require('@/assets/imgs/NoPath - Copy (5).png')"
          >
          <div style="width: calc(100% - 10rem); height: 9rem" class="d-flex flex-column justify-content-around gap-3 overflow-hidden">
            <p class="font_larger bold">{{ teacher.name }}</p>
            <p class="font_normal text-truncate-multiline">{{ teacher.bio }}</p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'TeachersListView',
  data() {
    return {
      teachers: [],
      loading: false,
      searchQuery: '',
      sortOption: 'followers',
      searchTimeout: null
    }
  },
  mounted() {
    this.fetchTeachers()
  },
  methods: {
    async fetchTeachers() {
      this.loading = true
      try {
        const userId = localStorage.getItem('user_id')
        const formData = createFormData({
          user_id: userId,
          search: this.searchQuery,
          sort: this.sortOption
        })

        const response = await apiClient.post('/teachers_profile', formData)

        if (response.data.status === 'ok' && response.data.data) {
          this.teachers = response.data.data.data || []
        } else {
          this.teachers = []
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      this.searchTimeout = setTimeout(() => {
        this.fetchTeachers()
      }, 500)
    },
    toggleSort() {
      this.sortOption = this.sortOption === 'followers' ? 'newest' : 'followers'
      this.fetchTeachers()
    },
    goToProfile(id) {
      this.$router.push({ 
        name: 'TeacherProfile',
        params: { id: id }
      })
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.text-truncate-multiline {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>